// Mock data for Splitara — will be replaced by backend later

export const APP_LINKS = {
  ios: "https://apps.apple.com/de/app/splitara/id6764364971?l=en-GB",
  android: "https://play.google.com/store/apps/details?id=com.techhubcity.splitara&pcampaignid=web_share",
};

export const NAV_LINKS = [
  { label: "Features", href: "#features" },
  { label: "Get the app", href: "#get-app" },
  { label: "Reviews", href: "#reviews" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const HERO_STATS = [
  { title: "AI", subtitle: "itinerary builder" },
  { title: "PDF", subtitle: "trip exports" },
  { title: "iOS + Android", subtitle: "mobile ready" },
  { title: "Multi-currency", subtitle: "instant splits" },
];

export const FEATURES = [
  {
    icon: "CalendarRange",
    title: "Itinerary",
    body: "Day-by-day plans, dates, times, places, routes, and edits that stay shared with the whole group.",
    color: "emerald",
  },
  {
    icon: "Wallet",
    title: "Expenses",
    body: "Multi-currency spending, custom splits, settlements, exports, and payer/payee confirmation.",
    color: "amber",
  },
  {
    icon: "MapPinned",
    title: "Maps",
    body: "Pins, route order, directions, and transport modes so the trip makes sense on the ground.",
    color: "sky",
  },
  {
    icon: "MessagesSquare",
    title: "Group chat",
    body: "Trip-specific messaging, invite context, and notifications that only go to the right people.",
    color: "rose",
  },
  {
    icon: "Sparkles",
    title: "AI help",
    body: "Itinerary drafts, receipt scanning, category suggestions, and real-photo trip cover ideas.",
    color: "violet",
  },
  {
    icon: "Camera",
    title: "Memories",
    body: "Photos, notes, trip moments, and shareable recaps after everyone gets home.",
    color: "orange",
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Amelia R.",
    location: "Lisbon → Marrakech",
    quote:
      "We finally stopped fighting over who paid for what. Splitara did the math and the mood is chef's kiss.",
    avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&q=80",
    rating: 5,
  },
  {
    id: 2,
    name: "Kenji T.",
    location: "Tokyo → Bali",
    quote:
      "The AI drafted an entire 8-day itinerary in a minute. We tweaked it on the flight. Landed already planned.",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80",
    rating: 5,
  },
  {
    id: 3,
    name: "Priya S.",
    location: "Delhi → Amalfi Coast",
    quote:
      "Maps, chat, and expenses in one place. No more 4 apps and a spreadsheet duct-taped together.",
    avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=200&q=80",
    rating: 5,
  },
  {
    id: 4,
    name: "Lucas M.",
    location: "Berlin → Patagonia",
    quote:
      "Receipt scanning is witchcraft. Snap, split, settled. The group thinks I'm suddenly organised.",
    avatar: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?auto=format&fit=crop&w=200&q=80",
    rating: 5,
  },
];

export const FAQS = [
  {
    q: "Is Splitara free to use?",
    a: "Yes — the core planning, expense splitting, maps, and chat are free. Optional Pro features (like unlimited AI drafts and premium exports) unlock with a subscription you can cancel anytime.",
  },
  {
    q: "Which currencies are supported?",
    a: "All major world currencies with live conversion. Add expenses in the local currency; Splitara reconciles balances in each traveller's home currency at settlement.",
  },
  {
    q: "Can I use Splitara offline while travelling?",
    a: "Yes. Itineraries, expenses, maps, and receipts you've opened cache locally, so you can view and add new entries without signal. Everything syncs when you're back online.",
  },
  {
    q: "How does the AI itinerary builder work?",
    a: "Tell Splitara your destinations, dates, budget, and vibe. The AI drafts a day-by-day plan with places, transport, and time slots — you and your group edit collaboratively.",
  },
  {
    q: "Is my data private?",
    a: "Absolutely. Splitara uses encrypted storage, transparent privacy policies, and gives you full control including account and data deletion at any time.",
  },
  {
    q: "Can I invite friends who don't have accounts yet?",
    a: "Yes — send an invite link. Friends can view basic trip info as guests and get prompted to install the app to interact.",
  },
];

export const SHOWCASE_IMAGES = {
  heroBg: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=2400&q=88",
  planTogether: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=1600&q=86",
  splitClearly: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1600&q=86",
  maps: "https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?auto=format&fit=crop&w=1800&q=86",
  trust: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1600&q=86",
  phoneMockup: "https://images.unsplash.com/photo-1601925260368-ae2f83cf8b7f?auto=format&fit=crop&w=1200&q=86",
  memories: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=1600&q=86",
};

export const TRUST_POINTS = [
  "Transparent privacy, cookie, terms, and data deletion information",
  "Support contact for billing, account access, legal, and privacy requests",
  "Secure account controls for profile, password, subscriptions, and deletion",
  "Shared expense records are protected until balances are settled",
];
